import { render, staticRenderFns } from "./TemplateInputs.vue?vue&type=template&id=50341870"
import script from "./TemplateInputs.vue?vue&type=script&lang=js"
export * from "./TemplateInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports